import { render, staticRenderFns } from "./caozuoxingwei_page.vue?vue&type=template&id=a97b548e&scoped=true"
import script from "./caozuoxingwei_page.vue?vue&type=script&lang=js"
export * from "./caozuoxingwei_page.vue?vue&type=script&lang=js"
import style0 from "./caozuoxingwei_page.vue?vue&type=style&index=0&id=a97b548e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97b548e",
  null
  
)

export default component.exports